import queryString from "query-string";
import { KeyedMutator } from "swr";

import { API_URL } from "constants/api";
import useFirebaseContext from "hooks/useFirebaseContext";
import { useSwr } from "hooks/useSwr";

type FetchNewsResponse = {
  data: NewsItem[];
  pagination: CursorPagination;
};

const initialPagination: CursorPagination = {
  hasNextPage: false,
  hasPreviousPage: false,
  startCursor: null,
  endCursor: null,
  totalPages: 1,
};

const useFetchNews = ({
  pageSize,
  after,
  before,
}: {
  pageSize: number;
  after: string | null;
  before: string | null;
}): {
  news: NewsItem[];
  pagination: CursorPagination;
  error: Error | null;
  mutate: KeyedMutator<FetchNewsResponse>;
  isLoading?: boolean;
} => {
  useFirebaseContext();
  const params = { pageSize, after: after || undefined, before: before || undefined };

  const { data, error, mutate, isValidating } = useSwr<FetchNewsResponse>(
    `${API_URL}/news?${queryString.stringify(params)}`,
    { revalidateIfStale: true, revalidateOnFocus: true, revalidateOnReconnect: true }
  );

  return {
    news: data?.data ?? [],
    pagination: data?.pagination ?? initialPagination,
    error: error ?? null,
    mutate,
    isLoading: !data && isValidating,
  };
};

export default useFetchNews;
